import React, { useCallback, useState } from 'react';
import { Dropdown, Menu, message, Tooltip } from 'antd';

import style from './index.less';

interface ClueType {
  content: string;
  value: string;
}

interface ItemPropsTypes {
  match: string;
  handleAddClue: (a: ClueType) => void;
  getClueComponent?: () => JSX.Element;
  handlePhoneCheck?: (tel: string) => void;
}

type CluesTypes = Array<Record<'label' | 'value', string>>;

const clueTypes: CluesTypes = [
  { label: '电话', value: 'tel' },
  { label: '微信', value: 'weixin' },
  { label: 'QQ', value: 'qq' }
];

const ClueMenu = ({ match, handleAddClue, getClueComponent, handlePhoneCheck }: ItemPropsTypes) => {
  const [visible, setVisible] = useState(false);

  const copyInClipboard = useCallback(content => {
    const input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', content ? content.trim() : '');
    document.body.appendChild(input);
    input.setSelectionRange(0, 9999);
    if (document.execCommand) {
      input.select();
      document.execCommand('copy');
    }
    document.body.removeChild(input);
    message.success('复制成功');
  }, []);

  const getMenu = (match: string) => {
    // 判断是否是手机号
    const mobileRegex = /^1[3-9]\d{9}$/;
    const isPhone = mobileRegex.test(match);

    const items: any[] = [
      {
        key: 'copy',
        label: '复制',
        onClick: () => copyInClipboard(match)
      },
      {
        key: 'add',
        label: '添加',
        children: clueTypes.map(({ label, value }) => ({
          key: value,
          label,
          onClick: () => {
            handleAddClue({ content: match ? match.trim() : '', value });
          }
        }))
      }
    ];

    if (isPhone) {
      items.push({
        key: 'phoneCheck',
        label: '空号检测',
        onClick: () => {
          if (handlePhoneCheck) {
            handlePhoneCheck(match);
          }
        }
      });
    }

    return <Menu items={items} />;
  };
  if (!match) {
    return null;
  }
  return getClueComponent ? (
    <Dropdown dropdownRender={() => getMenu(match)} open={visible} onOpenChange={setVisible}>
      {getClueComponent()}
    </Dropdown>
  ) : (
    <span className={style.selected} onClick={() => setVisible(!visible)}>
      <Tooltip title={`线索长度${match.trim().length}位`}>{match}</Tooltip>
      <Dropdown dropdownRender={() => getMenu(match)} open={visible} onOpenChange={setVisible}>
        <span className={style.tip}></span>
      </Dropdown>
    </span>
  );
};

export default ClueMenu;
